import React from "react";
import iciciBankLogo from "../assets/images/icici_logo.webp";

function HeaderComponent() {
    return (
        <>
            <header>
                <div className="container">
                <a href="/"><img src={iciciBankLogo} alt="icici_logo" className="icici_logo" height="53px" width="269px"/></a>
                </div>
            </header>
        </>
    );
}

export default HeaderComponent;
